<template>

  <div>
    <h2>{{ $t('title.' + action + '-access-scheme') }}</h2>

    <el-tabs v-model="currentTab">

      <el-tab-pane :label="$t('tab.details')">
        <el-row :gutter="40">
          <el-col :span="12" :md="12" :sm="24" :xs="24">

            <access-form
              :access="accessScheme"
              :additional-fields="{'name': {type: 'text'}}"
              :buttons="[{title: 'submit', action: submit}, {title: 'cancel', action: cancel}]"
              />

          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane v-if="!accessScheme.new" :label="$t('tab.groups')">
        <el-row :gutter="40">
          <el-col :span="12">

            <h4>{{ $t('related-groups') }}</h4>

            <div>
              <el-select
                filterable
                remote
                :remote-method="filterSwitchGroups"
                :placeholder="$t('placeholder.switch_group')"
                v-model="selectedSwitchGroupId"
                @change="switchGroupSelected">

                <el-option
                  v-for="item in filterSwitchGroups()"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value" />

              </el-select>

              <el-select
                filterable
                remote
                :remote-method="filterMobileGroups"
                :placeholder="$t('placeholder.mobile_group')"
                v-model="selectedMobileGroupId"
                @change="mobileGroupSelected">

                <el-option
                  v-for="item in filterMobileGroups()"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value" />

              </el-select>

              <el-button
                type="primary"
                size="large"
                @click="submitGroups"
                :loading="isLoading">{{ $t('button.add-new') }}</el-button>
            </div>

            <data-table
              :model="groups"
              :columns="['switchGroupName', 'mobileGroupName']"
              :showSearch="false"
              :operations="[
                {
                  label: 'delete',
                  permission: 'DELETE_MOBILE_ACCESS_GROUP',
                  type: 'danger',
                  icon: 'delete',
                  method: deleteMobileAccessGroup
                }
              ]"/>

          </el-col>
        </el-row>

      </el-tab-pane>
    </el-tabs>
  </div>

</template>
<script>
import DataTable from 'components/DataTable'
import AccessForm from 'components/access/AccessForm'
import { post, deletex } from 'providers/http'

export default {
  name: 'access-sheme-details',
  data () {
    return {
      groups: [],
      currentTab: null,
      selectedSwitchGroupId: null,
      selectedMobileGroupId: null,
      isLoading: false
    }
  },
  computed: {
    accessScheme () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['access-schemes/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.accessScheme.new ? 'create' : 'edit'
    }
  },
  methods: {
    async submit (formModel) {
      /* eslint-disable camelcase */
      const {
        id = 'new',
        name,
        user_level_id,
        key_type,
        start_date,
        start_hour = formModel.duration[0].getHours(),
        start_minute = formModel.duration[0].getMinutes(),
        end_date,
        end_hour = formModel.duration[1].getHours(),
        end_minute = formModel.duration[1].getMinutes(),
        days = JSON.stringify(formModel.days)
      } = formModel

      const data = {
        name,
        user_level_id,
        key_type,
        start_date,
        days
      }

      if (key_type !== 'constant') {
        data.end_date = end_date

        if (key_type !== 'temporary') {
          data.start_hour = start_hour
          data.start_minute = start_minute
          data.end_hour = end_hour
          data.end_minute = end_minute
        }
      }

      try {
        await post(`api/v1/access-schemes/${id}`, data)

        this.showSuccess('access-scheme-saved')
      }
      catch (err) {
        console.error(err)

        this.showError('failed-to-save-access-scheme')
      }
      this.$router.back()
    },
    filterSwitchGroups (query) {
      return this.$store.getters['switch-groups/data'](this.$store.dispatch)
        .map(i => ({ label: i.name, value: i.id }))
        .filter(i => i.label.toLowerCase().includes((query || '').toLowerCase()))
    },
    filterMobileGroups (query) {
      return this.$store.getters['mobile-groups/data'](this.$store.dispatch)
        .map(i => ({ label: i.name, value: i.id }))
        .filter(i => i.label.toLowerCase().includes((query || '').toLowerCase()))
    },
    async submitGroups () {
      const data = {
        accessSchemeId: this.accessScheme.id,
        switchGroupId: this.selectedSwitchGroupId,
        mobileGroupId: this.selectedMobileGroupId
      }

      try {
        await post('api/v1/access-schemes/set-groups', data)
        this.showSuccess('groups-updated')
        this.getGroups()
      }
      catch (err) {
        console.error(err)
      }
    },
    switchGroupSelected (switchGroupId) {
      this.selectedSwitchGroupId = switchGroupId
    },
    mobileGroupSelected (mobileGroupId) {
      this.selectedMobileGroup = mobileGroupId
    },
    async getGroups () {
      const id = this.$route.params.id

      try {
        const groups = await post('api/v1/mobile-access-groups/search', {
          accessSchemeId: id,
          size: 10000000000
        })
        this.groups = groups.data
      }
      catch (err) {
        console.error(err)
      }
    },
    async deleteMobileAccessGroup (row) {
      const id = row.id

      await deletex(`api/v1/mobile-access-groups/${id}`)
      this.groups = this.groups.filter(g => g.id !== id)
    },
    cancel () {
      this.$router.back()
    }
  },
  beforeMount () {
    this.getGroups()
  },
  components: { DataTable, AccessForm }
}
</script>



// WEBPACK FOOTER //
// AccessSchemeDetails.vue?01c194d1